import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledSlider, Track, Thumb, TOOLTIP_STYLES, TOOLTIP_ARROW, TOOLTIP_INNER_STYLES } from './StyledComponents';

const MultiRangePriceSlider = ({ payment, setPayment, min, max }) => {
    const { t } = useTranslation();
    const safeMax = max > min ? max : min + 1;
    const initialValues = useMemo(() => payment
        ? [Math.max(min, payment.minPayment), Math.min(safeMax, payment.maxPayment)]
        : [min, safeMax], [payment, min, safeMax]);
    const [sliderValues, setSliderValues] = useState(initialValues);
    const [tooltipValues, setTooltipValues] = useState({ min: initialValues[0], max: initialValues[1] });

    useEffect(() => {
        setSliderValues(initialValues);
        setTooltipValues({ min: initialValues[0], max: initialValues[1] });
    }, [initialValues]);

    return <>
        <div className="tooltip tooltip-main top" role="presentation" 
        style={TOOLTIP_STYLES}>
            <div className="tooltip-arrow"
            style={TOOLTIP_ARROW}></div>
            <div className="tooltip-inner"
            style={TOOLTIP_INNER_STYLES}
            >{tooltipValues.min} - {tooltipValues.max}</div>
        </div>
         <StyledSlider 
        min={min}
        max={safeMax}
        onAfterChange={values => setPayment({ minPayment: values[0], maxPayment: values[1] })}
        onChange={values => {
            setSliderValues(values);
            setTooltipValues({ min: values[0], max: values[1] });
        }}
        value={sliderValues}
        renderTrack={Track} 
        renderThumb={Thumb} />
        {payment && <button
            type="button"
            className="button ripple-effect"
            style={{ marginTop: 18, padding: '7px 14px' }}
            onClick={() => setPayment(null)}>
            {t('ResetPaymentFilter')}
        </button>}
     </>;
}

export default MultiRangePriceSlider;
